var Home = function () {

    var $window, $html, $body, $pageContent, $projectBlocks, $projectHeaders, $heroBlock, $heroBlockVideo,
        $faderReference, $markerReference, $pusherReference,
        $straplines, $storyStraplines, $breakers, $titles, $homeContent, $workLink;

    var breakerSelectors = [
        '.home-featured-strapline-block',
        '.home-news-break',
        '.newsletter-block',
        '.end-block'
    ];

    var layout = {
        fader: {},
        marker: {},
        pusher: {},
        straplines: [
            /*
            {
                el: …,
                top: …,
                bottom: …,
                children: [$…]
            }
            */
        ],
        storyStraplines: [],
        breakers: [],
        titles: [],
        hero: {},
        video: {},
        content: {},
    };




    function init () {
        $window = $(window);
        $html = $('html');
        $body = $('body');
        $homeContent = $('.home-content');
        $pageContent = $body;
        if (!$pageContent.length) return;

        $faderReference = $('.util-fader');
        $markerReference = $('.util-marker');
        $pusherReference = $('.util-pusher');
        $straplines = $pageContent.find('.home-featured-strapline-block');
        $storyStraplines = $pageContent.find('.story-strapline-block');
        $titles = $straplines.find('.title');
        $workLink = $('.work-link a');

        $breakers = $pageContent.find(breakerSelectors.join(','));
        $projectBlocks = $pageContent.find('.home-featured-project-block');
        $projectHeaders = $projectBlocks.find('.header:not(.story-header)');
        $heroBlock = $('.home-header-block');
        $heroBlockVideo = $heroBlock.find('video');

        enableInlineVideoPlayback();

        updateLayoutCache();

        registerMediaQueries();
        registerEvents();

        $window.trigger('scroll');
    }

    function isHomeContent () {
        return $homeContent.length;
    }


    function easeOutQuad(t) {
        return t*(2-t);
    }



    function enableInlineVideoPlayback () {
        if(!$('.home-header-block video').get(0)) return
        enableInlineVideo($('.home-header-block video').get(0), { iPad: true });
    }



    function updateTitlesAlpha() {
        var fadeMinY = 70;
        var fadeMaxY = 250;
        $projectHeaders.each(function() {
            var pos = this.getBoundingClientRect();
            this.style.opacity = easeOutQuad(clampedRange(fadeMinY,fadeMaxY,pos.top)) + '';
        });
    }



    function resetTitlesAlpha () {
        $projectHeaders.each(function() {
            this.style.opacity = '1';
        });
    }




    function pauseHeroVideoOnScroll() {
        var scrollY = window.pageYOffset;
        var videoEl = $heroBlockVideo.get(0);
        if(!videoEl) return;

        var isScrolledOut = (layout.video.bottom - scrollY) > 0;

        if (!isScrolledOut && !videoEl.paused) {
            videoEl.pause();
        }
        if (isScrolledOut && videoEl.paused) {
            videoEl.play();
        }
    }




    function scrollToMainContent () {
        const $pageContentEl = $('article.page-content');
        const navigationContainerHeight = $('.logo-menu').outerHeight();
        const scrollVal = $pageContentEl.offset().top - navigationContainerHeight + 1;
        $('html,body').animate({
            scrollTop: scrollVal,
        }, 500, 'swing');
    }

    function updateLayoutCache () {
        if($heroBlock[0]) {
            layout.hero.top = $heroBlock[0].offsetTop;
            layout.hero.bottom = layout.hero.top + $heroBlock[0].offsetHeight;
        }

        if($heroBlockVideo[0]){
            layout.video.top = $heroBlockVideo[0].offsetTop;
            layout.video.bottom = layout.video.top + $heroBlockVideo[0].offsetHeight;
        }

        if($faderReference[0]) {

            layout.fader.top = $faderReference[0].offsetTop;
            layout.fader.bottom = layout.fader.top + $faderReference[0].offsetHeight;
        }

        if($pusherReference[0]) {
            layout.pusher.top = $pusherReference[0].offsetTop;
            layout.pusher.bottom = layout.pusher.top + $pusherReference[0].offsetHeight;
        }

        if($markerReference[0]) {
            layout.marker.top = $markerReference[0].offsetTop;
        }
        if($homeContent[0]) {
            layout.content.top = $homeContent[0].offsetTop;
        }


    }


    function clampedRange (min, max, value) {
        var clampedVal = Math.max(min, Math.min(max, value));
        return (clampedVal - min) / (max - min);
    }


    function fadeStraplines () {
        var scrollY = window.pageYOffset;
        var faderTop = scrollY + layout.fader.top;
        var faderBottom = scrollY + layout.fader.bottom;

        /*
        Strapline behaviour.
        Vary opacity from 1 to 0.
        */
        layout.straplinesChildren.forEach(function (obj) {
            var posRange = clampedRange(faderTop, faderBottom, obj.top);
            obj.el[0].style.opacity = posRange + '';
        });
    }

    function fadeStoryStraplines () {
        var scrollY = window.pageYOffset;
        var offset;

        if ($window.width() >= 1200) {
            offset = 120;
        } else if ($window.width() >= 992) {
            offset = 90;
        } else {
            offset = 60;
        }

        var faderTop = scrollY + layout.fader.top + offset;
        var faderBottom = scrollY + layout.fader.bottom + offset;

        layout.storyStraplinesChildren.forEach(function (obj) {
            var posRange = clampedRange(faderTop, faderBottom, obj.top);
            obj.el[0].style.opacity = posRange + '';
        });
    }



    function trackScroll () {
        var scrollY = window.pageYOffset;
        var markerScrollTop = scrollY + layout.marker.top;
        var pusherTop = scrollY + layout.pusher.top;
        var pusherBottom = scrollY + layout.pusher.bottom;
        var pusherHeight = layout.pusher.bottom - layout.pusher.top;

        /*
        Strapline Title behaviour
        Sticks when it reaches the marker.
        */
        var stickyTitle = false;
        layout.titles.forEach(function (obj) {
            // Prepare stuff
            var nextBreaker = null;
            var style = obj.el[0].style;
            // Find the next "breaker"
            layout.breakers.forEach(function (breaker) {
                if (nextBreaker) return;
                if (breaker.top > obj.top) {
                    nextBreaker = breaker;
                }
            })
            if (nextBreaker == null) return;
            var breakerPosRange = clampedRange(pusherTop, pusherBottom, nextBreaker.top);

            // Place things
            style.position = 'absolute';
            style.top = 'auto';
            obj.el.removeClass('active');

            // While the title is above the marker, leave it in place
            if (markerScrollTop < obj.top) {
                style.transform = 'translate3d(0,0,0)';
                return;
            }

            // With the title below the marker, stamp the title in place
            style.transform = 'translate3d(0,' + (nextBreaker.top - obj.top - pusherHeight + layout.marker.top) + 'px,0)';

            // While the breaker is out of range keep the title fixed
            if (breakerPosRange >= 1) {
                style.position = 'fixed';
                style.top = layout.marker.top + 'px';
                style.transform = 'translate3d(0,0,0)';
                obj.el.addClass('active');
                stickyTitle = true;
            }

        });

        $body.toggleClass('sticky-title', stickyTitle);
    }




    function getAbsoluteOffset (el, offsetParent) {
        var _x = 0;
        var _y = 0;
        while ( el && !isNaN( el.offsetLeft ) && !isNaN( el.offsetTop ) ) {
            _x += el.offsetLeft;
            _y += el.offsetTop;
            if (offsetParent && el.offsetParent === offsetParent) {
                break;
            }
            el = el.offsetParent;
        }
        return { top: _y, left: _x };
    }




    function removeSticky() {
        layout.titles.forEach(function (obj) {
            var style = obj.el[0].style;
            style.position = 'absolute';
            style.top = 'auto';
            obj.el.removeClass('active');
        });
        layout.straplinesChildren.forEach(function (obj) {
            obj.el[0].style.opacity = 1;
        });
    }


    function handleWorkLink (event) {
        if (isHomeContent()) {
            event.preventDefault();
            if ($html.hasClass('navigation-active')) {
                $html.removeClass('navigation-active');
            }
            // setTimeout(function () {
            //     scrollToMainContent();
            // }, 300);
        }
        if ($body.css('padding-right')) {
            $body.css({ 'padding-right': 0 });
        };
    }


    function registerEvents () {
        $window.on('scroll', function () {
            requestAnimationFrame(pauseHeroVideoOnScroll);
        });

        // $window.on('load',function () {
        //     const { pathname, hash } = document.location;
        //
        //     if (hash === '#work' || ($homeContent.length && pathname !== '/')) {
        //         scrollToMainContent();
        //     }
        // });

        $workLink.on('click', handleWorkLink);

        $body.on('click', '.home-header-block', scrollToMainContent);

        $window.on('resize', $.debounce(250, updateLayoutCache));
    }




    function registerMediaQueries () {
        enquire.register('screen and (min-width: 900px)', {
            // SM and up
            match : function() {
                $window.on('scroll.trackScroll', trackScroll);
                $window.on('scroll.updateTitlesAlpha', function () {
                    requestAnimationFrame(updateTitlesAlpha);
                });
            },
            // up to, excluding SM
            unmatch : function() {
                $window.off('scroll.trackScroll');
                $window.off('scroll.updateTitlesAlpha');
                resetTitlesAlpha();
                // removeSticky();
            }
        });
    }




    return {
        init: init
    }

}();
